import { Typography } from '@components/atoms/Typography/Typography'

interface NoRemoteVideoViewProps {
  message?: string
}

export function NoRemoteVideoView({
  message = "En attente d'autres participants ou d'un partage."
}: NoRemoteVideoViewProps) {
  return (
    <div className="flex h-full items-center justify-center">
      <Typography type="body" size="lg" className="text-white font-medium">
        {message}
      </Typography>
    </div>
  )
}
